var map = {
	"./chapter-01.json": 2515,
	"./chapter-02.json": 6354,
	"./chapter-03.json": 3085,
	"./chapter-04.json": 5228,
	"./chapter-05.json": 2367,
	"./chapter-06.json": 5550,
	"./chapter-07.json": 9737,
	"./chapter-08.json": 1752,
	"./chapter-09.json": 3163,
	"./chapter-10.json": 7501,
	"./chapter-11.json": 9874,
	"./chapter-12.json": 4579,
	"./chapter-13.json": 2720,
	"./chapter-14.json": 1849,
	"./chapter-15.json": 766,
	"./chapter-16.json": 1839,
	"./chapter-17.json": 9948,
	"./chapter-18.json": 8005,
	"./chapter-19.json": 7562,
	"./chapter-20.json": 7334,
	"./chapter-21.json": 1329,
	"./chapter-22.json": 4980,
	"./chapter-23.json": 3703,
	"./chapter-24.json": 3882,
	"./chapter-25.json": 3589,
	"./chapter-26.json": 7784,
	"./chapter-27.json": 1723,
	"./chapter-28.json": 1582,
	"./chapter-29.json": 6521,
	"./chapter-30.json": 59,
	"./chapter-31.json": 4360,
	"./chapter-32.json": 5573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2737;